import Flickity from './FlickityExtended';

const AUTOPLAY_CLASS = 'slider--autoplay';
const INIT_CLASS = 'slider--init';
const FINISHED_CLASS = 'slider--finished';

// Remove autoplay class on stop
Flickity.prototype.stopPlayer = function() {
    this.player.stop();
    this.element.classList.remove(AUTOPLAY_CLASS);
};

const STRINGS = document.body.dataset.slider.split(',');

// Set additional default values
const DEFAULTS = {
    pauseAutoPlayOnHover: false,
    imagesLoaded: true,
    pageDotAriaLabel: STRINGS[0],
    previousAriaLabel: STRINGS[1],
    nextAriaLabel: STRINGS[2],
    on: {
        ready: function() {
            if (this.options.autoPlay) {
                this.element.classList.add(AUTOPLAY_CLASS);
            }
            setTimeout(() => {
                this.element.classList.add(INIT_CLASS);
                this.element.classList.add(FINISHED_CLASS);
            }, 10);
        }
    },
    arrowShape:
        'M24.7984 48.0464l46.23-46.23a2.7643 2.7643 0 0 1 3.9227 0 2.7643 2.7643 0 0 1 0 3.9226L30.6927 49.9974 74.951 94.2558a2.7643 2.7643 0 0 1 0 3.9227C74.417 98.7125 73.6983 99 73 99c-.6984 0-1.4172-.267-1.9511-.8215l-46.23-46.23c-1.0885-1.068-1.0885-2.8342-.0206-3.9021z'
};

Object.assign(Flickity.defaults, DEFAULTS);

// Fix resize event
let resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
    this.element.classList.remove(FINISHED_CLASS);
    resize.apply(this, arguments);
    setTimeout(() => {
        this.element.classList.add(FINISHED_CLASS);
    }, 10);
}

// Add localized labels with this duck-punch code
// https://metafizzy.co/blog/duck-punching-prototype/

let addDots = Flickity.PageDots.prototype.addDots;
Flickity.PageDots.prototype.addDots = function() {
    addDots.apply(this, arguments);
    let ariaLabel = this.parent.options.pageDotAriaLabel;
    this.dots.forEach(function(dot, i) {
        let label = ariaLabel.replace('%n', i + 1);
        dot.setAttribute('aria-label', label);
    });
};

let _createButton = Flickity.PrevNextButton.prototype._create;
Flickity.PrevNextButton.prototype._create = function() {
    _createButton.apply(this, arguments);
    let optionName = this.isPrevious ? 'previous' : 'next';
    let label = this.parent.options[optionName + 'AriaLabel'];
    this.element.setAttribute('aria-label', label);
};

export default Flickity;
